/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'GoalPanel.header.title': 'Meta',
  'goal-panel.generic-error.description': 'Comprueba tu conexión a Internet e inténtalo de nuevo.',
  'goal-panel.generic-error.title': 'Se ha producido un error',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Mostrar más campos',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Mostrar menos',
  'goal-panel.goal-panel-tabs.about-tab-title': 'Acerca de',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Proyectos',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Actualizaciones',
  'goal-panel.goal-title.edit-button-label': 'Editar título de la meta',
  'goal-panel.goal-title.update-error-description': 'No se ha podido actualizar el contenido de {goalName}',
  'goal-panel.goal-title.update-error-title': 'Se ha producido un error',
  'goal-panel.goal-title.validation-message': 'Introduce un título para tu meta',
};
